const validTimestamp = (value) => {
    const timestamp = value ? new Date(value).getTime() : Number.NaN;
    return Number.isFinite(timestamp) ? timestamp : null;
};

export const getStudentExamTiming = (exam = {}, now = Date.now()) => {
    if (exam.status === 'closed' || exam.timing_status === 'closed') return 'closed';

    const startsAt = validTimestamp(exam.starts_at);
    const endsAt = validTimestamp(exam.ends_at);

    // Client-side time is intentional: a card that was loaded while open must
    // immediately become unavailable when its deadline passes.
    if (endsAt !== null && now >= endsAt) return 'ended';
    if (startsAt !== null && now < startsAt) return 'upcoming';
    if (exam.is_open === true) return 'open';

    if (['upcoming', 'open', 'ended'].includes(exam.timing_status)) {
        return exam.timing_status;
    }
    return exam.status === 'published' ? 'open' : 'closed';
};

export const studentExamTimingCopy = {
    upcoming: {
        label: 'شروع‌نشده',
        action: 'هنوز شروع نشده',
    },
    open: {
        label: 'فعال',
        action: 'شروع آزمون',
    },
    ended: {
        label: 'پایان‌یافته',
        action: 'زمان آزمون پایان یافته',
    },
    closed: {
        label: 'بسته‌شده',
        action: 'آزمون بسته شده',
    },
};
